import { defineMessages } from 'react-intl';

export default defineMessages({
  deleteAction: {
    id: 'frontbucket.repository.source.deleteAction',
    description: 'Menu action to delete a file',
    defaultMessage: 'Delete',
  },
  deleteActionDisabled: {
    id: 'frontbucket.repository.source.deleteAction.disabled',
    description:
      'Explain that files can only be deleted from the head of a branch',
    defaultMessage: 'Deleting files is only allowed from the head of a branch',
  },
  menuLabel: {
    id: 'frontbucket.repository.source.file.actions.menu.label',
    description: 'Accessibility text label for source file actions menu',
    defaultMessage: 'Source file actions',
  },
  openRawAction: {
    id: 'frontbucket.repository.source.file.openRawAction',
    description: 'Menu action to open the "raw" version of a file',
    defaultMessage: 'Open raw',
  },
  renameAction: {
    id: 'frontbucket.repository.source.file.renameAction',
    description: 'Menu action to rename a file',
    defaultMessage: 'Rename',
  },
  renameActionDisabled: {
    id: 'frontbucket.repository.source.file.renameAction.disabled',
    description:
      'Explain that files can only be renamed from the head of a branch',
    defaultMessage: 'Renaming files is only allowed from the head of a branch',
  },
  toggleAnnotateAction: {
    id: 'frontbucket.repository.source.file.toggleAnnotateAction',
    description:
      'Menu action to toggle git blame/annotate information for a file',
    defaultMessage: 'Annotate/Blame',
  },
});
